const asText = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).trim();
};

export const getRatingValue = (review) => {
  const numericValue = Number(review?.rating ?? 0);
  if (!Number.isFinite(numericValue)) return 0;
  return Math.min(5, Math.max(0, numericValue));
};

export const renderStarsText = (rating) => {
  const safeRating = Math.min(5, Math.max(0, Number(rating) || 0));
  return "\u2605".repeat(safeRating) + "\u2606".repeat(5 - safeRating);
};

export const getReviewText = (review) =>
  asText(review?.review || review?.comment || review?.message || review?.description);

export const getReviewTitle = (review) => asText(review?.title || review?.subject);

export const getCustomerName = (review) =>
  asText(
    review?.customer_name ||
      review?.customer?.name ||
      review?.customerName ||
      review?.name ||
      review?.user_name ||
      review?.user?.name ||
      review?.user_id
  );

export const getPartnerName = (review) =>
  asText(review?.partner_name || review?.partner?.name || review?.partnerName || review?.partner_id);

export const getServiceName = (review) =>
  asText(review?.service_name || review?.service?.name || review?.serviceName || review?.service_id);

export const getStatusMeta = (statusValue) => {
  const normalizedStatus = asText(statusValue).toLowerCase();

  if (["1", "approved", "approve", "active"].includes(normalizedStatus)) {
    return {
      label: "Approved",
      className: "bg-green-100 text-green-700",
    };
  }

  if (["2", "rejected", "reject", "inactive"].includes(normalizedStatus)) {
    return {
      label: "Rejected",
      className: "bg-red-100 text-red-700",
    };
  }

  return {
    label: "Pending",
    className: "bg-yellow-100 text-yellow-700",
  };
};

export const formatReviewDate = (value, includeTime = false) => {
  if (!value) return "-";

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return asText(value) || "-";
  }

  return includeTime ? parsedDate.toLocaleString() : parsedDate.toLocaleDateString();
};

export const getReviewMedia = (review) => {
  if (Array.isArray(review?.media)) return review.media;
  if (Array.isArray(review?.review_media)) return review.review_media;
  if (Array.isArray(review?.customer_media)) return review.customer_media;
  return [];
};
